import { isRef } from "vue";
import { B2BDealType, B2CDealType, CostDealType } from "@/app/constants";

import { ReactiveComponent } from "../../entities/base-component";
import { CalculationStrategy, PriceResult } from "../base/calculation.strategy";
import { unwrapRef } from "@/utils/reactive";

export class ExtraCalculationStrategy extends CalculationStrategy {
    calculate(component: ReactiveComponent): PriceResult {
        const extra = component.getParent();

        if (!extra) {
            return this.getDefaultResult();
        }

        return {
            price: this.calculatePriceForType(component, CostDealType),
            priceB2C: this.calculatePriceForType(component, B2CDealType),
            priceB2B: this.calculatePriceForType(component, B2BDealType),
        };
    }

    private calculatePriceForType(
        component: ReactiveComponent,
        dealType: string,
    ) {
        const qty = unwrapRef(component.qty);
        const price = component.price.getSystemPrice(dealType).getValue();

        return price * qty;
    }
}

export class ExtraDiscountedPageTotalCalculationStrategy extends CalculationStrategy {
    calculate(component: ReactiveComponent, [activePartitionsExtra]): PriceResult {
        if (!activePartitionsExtra) {
            return this.getDefaultResult();
        }

        return {
            price: this.calculateDiscountedExtraPageTotalPrice(
                activePartitionsExtra,
                CostDealType,
            ),
            priceB2C: this.calculateDiscountedExtraPageTotalPrice(
                activePartitionsExtra,
                B2CDealType,
            ),
            priceB2B: this.calculateDiscountedExtraPageTotalPrice(
                activePartitionsExtra,
                B2BDealType,
            ),
        };
    }

    private calculateDiscountedExtraPageTotalPrice(
        activePartitionsExtra: any,
        dealType: string,
    ) {
        const discountedExtraList = activePartitionsExtra?.components.filter((item) => Boolean(item.discount));

        const total = discountedExtraList?.reduce(
            (acc, item) => acc + item.sum.getSystemPrice(dealType).getValue(),
            0,
        );

        return total;
    }
}

export class ExtraTotalCalculationStrategy extends CalculationStrategy {
    calculate(components: ReactiveComponent[]): PriceResult {
        return {
            price: this.calculatePriceForType(components, CostDealType),
            priceB2C: this.calculatePriceForType(components, B2CDealType),
            priceB2B: this.calculatePriceForType(components, B2BDealType),
        };
    }

    private calculatePriceForType(
        components: ReactiveComponent[],
        dealType: string,
    ) {
        if (!components || components.length === 0) {
            return 0;
        }

        return components.reduce((total, child) => {
            const sum = child.sum.getSystemPrice(dealType).getValue();

            return total + sum;
        }, 0);
    }
}
